import {
  PaymentFlowType,
  humanizePaymentFlowType,
} from '../../../constants/user-info/paymentFlowType';

export const getHumanizePaymentFlowType = (paymentFlowType: PaymentFlowType): string => {
  return humanizePaymentFlowType[paymentFlowType] ?? paymentFlowType;
};
